export default "__VITE_ASSET__ByDkgBip__"